module.exports = __webpack_public_path__ + "static/media/exclamation-circle.a1e197f5.svg";